// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
export const tryParseNumber = ({
  value,
  parseInt: parseIntIn,
}: { readonly value: string; readonly parseInt: boolean }) => {
  const result = Number(value);
  if (Number.isNaN(result) || value === '') {
    return undefined;
  }
  if (parseIntIn && !Number.isInteger(result)) {
    return undefined;
  }

  return result;
};
